import { useTranslation } from "react-i18next";
import { ORDER_STATUSES, type OrderStatus } from "@nh/shared";
import { Badge, type BadgeVariant } from "@/shared/ui/core";

/**
 * El estado de una orden, con el mismo color en el listado y en el
 * detalle. Tipado como `Record<OrderStatus, …>`: si el contrato añade
 * un estado, esto deja de compilar en vez de pintar una insignia gris
 * sin etiqueta.
 */
const STATUS_VARIANTS: Record<OrderStatus, BadgeVariant> = {
  pending: "warning",
  paid: "info",
  shipped: "indigo",
  delivered: "success",
  completed: "success",
  cancelled: "error",
};

export const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  pending: "Pendiente",
  paid: "Pagada",
  shipped: "Enviada",
  delivered: "Entregada",
  completed: "Completada",
  cancelled: "Cancelada",
};

export function OrderStatusBadge({ status }: { status: OrderStatus }) {
  const { t } = useTranslation();
  return (
    <Badge variant={STATUS_VARIANTS[status]} size="sm" dot>
      {t(ORDER_STATUS_LABELS[status])}
    </Badge>
  );
}

/**
 * Las opciones del selector de estado, traducidas y en el orden del
 * ciclo de vida (`ORDER_STATUSES`), no en el orden de las etiquetas.
 */
export function useOrderStatusOptions(): { value: OrderStatus; label: string }[] {
  const { t } = useTranslation();
  return ORDER_STATUSES.map((status) => ({
    value: status,
    label: t(ORDER_STATUS_LABELS[status]),
  }));
}
